import * as t from 'io-ts'

import fetchApi from "ui-io/fetch-api";

const createTaskCodec = t.type({
	task_id: t.string
})
type TaskBody = {
	taskId:string,
	companyID:string,
	assignee: string
	current_state: string
	type: string
	isFastlaneTask: boolean
	tags?: string[]
	configuration?: Object
	oldCompanyDetail?:Object
}

export const taskAddMutation = ({
	body,
}: {
	body: TaskBody
}) =>
	fetchApi({
		service: 'admin-service',
		method: 'POST',
		pathname: `/tasks/create-task`,
		body: body,
		codec: createTaskCodec,
	})
